"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class WorkflowModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.associatedDataIds = [];
        this.orConditions = [];
        this.actions = [];
        super.init(o);
    }
    get __typename() {
        return 'Workflow';
    }
    set __typename(v) {
    }
    get orConditionsText() {
        var _a;
        let text = '';
        (_a = this.orConditions) === null || _a === void 0 ? void 0 : _a.map((v, i) => {
            var _a;
            text = `${text}(`;
            (_a = v.andConditions) === null || _a === void 0 ? void 0 : _a.map((c, j) => {
                var _a, _b, _c;
                text = `${text + c.queryFieldKey} ${c.operator} ${((_a = c.value.from) === null || _a === void 0 ? void 0 : _a.toString()) || ((_b = c.value.to) === null || _b === void 0 ? void 0 : _b.toString()) || c.value.title.join(',')}${c.value.to ? ` and ${(_c = c.value.to) === null || _c === void 0 ? void 0 : _c.toString()}` : ''}${j < v.andConditions.length - 1 ? ' and ' : ' '}`;
            });
            text = `${text}) ${i < this.orConditions.length - 1 ? ' or ' : ' '}`;
        });
        return text;
    }
}
exports.WorkflowModel = WorkflowModel;
WorkflowModel.ALL_FIELDS = `id,
		event,
		enabled,
		title,
		lastTriggered,
		firstTriggered,
		lastActioned,
		associatedDataIds,
		orConditions,
		schedule,
		actions`;
exports.default = WorkflowModel;
ModelRegistry_1.default[DataType_1.default.WORKFLOW] = WorkflowModel;
